import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { DeleteTags, GetAllTags } from '../services/tagservice';
import Spinner from '../components/Spinner'; // Optional: Add a spinner for loading

function TagsList() {
    const [data, setData] = useState();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [totalCount, setTotalCount] = useState(0);
    const location = useLocation();
    const { successMessage } = location.state || {};
    let navigate = useNavigate();
    const totalPages = Math.ceil(totalCount / pageSize);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchData(page, pageSize);
        toast(successMessage);
    }, []);

    const fetchData = async (currentPage = 1, currentPageSize = 50) => {
        setLoading(true);
        try {
            const response = await GetAllTags(currentPage, currentPageSize);
            const jsonData = typeof response === 'string' ? JSON.parse(response) : response;
            setData(jsonData.tags || []);
            setTotalCount(jsonData.totalCount || 0);
        } catch (error) {
            console.error('Error fetching the data:', error);
            setLoading(false);
        }
        setLoading(false);
    }

    const handleEdit = (id) => {
        navigate('/tags/add?pk=' + id);
    };

    const handleDelete = async (recordId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this tag?");
        if (isConfirmed) {
            const data = await DeleteTags(recordId);
            await fetchData();
            toast("Tag deleted successfully!");
        }
    };

    const changePage = (p) => {
        if (p >= 1 && p <= totalPages) setPage(p);
    };

    const pageNumbers = () => {
        const pages = [];
        let start = Math.max(1, page - 2);
        let end = Math.min(totalPages, page + 2);

        if (start > 1) pages.push(1, '...');
        for (let i = start; i <= end; i++) pages.push(i);
        if (end < totalPages) pages.push('...', totalPages);

        return pages;
    };

    const startItem = (page - 1) * pageSize + 1;
    const endItem = Math.min(page * pageSize, totalCount);

    return (
        <>
            {loading && <Spinner overlay={true} text="Loading pages..." />}
            <div class="row">
                <div class="col-md-12 grid-margin stretch-card">
                    <div className="card shadow-sm">
                        <div class="card-body">
                            <div className="d-flex justify-content-between mb-3">
                                <h5 className="card-title mb-0">All Tags</h5>
                                <Link to="/tags/add" className='nav-link'>
                                    <button type="button" className="btn btn-primary">New Tag</button>
                                </Link>
                            </div>

                            <div className="table-responsive position-relative">
                                <table className="table table-striped table-hover table-borderless align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Pk</th>
                                            <th>Name</th>
                                            <th>Paramlink</th>
                                            <th>Post Count</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data?.map((item) => (
                                                <tr>
                                                    <td>{item.pk}</td>
                                                    <td class="font-weight-bold">{item.name}</td>
                                                    <td>{item.paramlink}</td>
                                                    <td>{item.count}</td>
                                                    <td>
                                                        <i
                                                            className="mdi mdi-tooltip-edit mdi-big font20 pointer"
                                                            title="Edit Record"
                                                            onClick={() => handleEdit(Number(item.pk))}
                                                        ></i>
                                                        <i
                                                            className="mdi mdi-delete mdi-big font20 pointer"
                                                            title="Delete Record"
                                                            onClick={() => handleDelete(item.pk)}
                                                        ></i>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination & Page Info */}
                            <div className="d-flex justify-content-between align-items-center mt-4 p-3 bg-light rounded">
                                <div className="d-flex align-items-center">
                                    <span className="text-muted">
                                        Showing <strong>{startItem}-{endItem}</strong> of <strong>{totalCount}</strong> Records
                                    </span>
                                </div>

                                <div className="d-flex align-items-center">
                                    <button
                                        className="btn btn-outline-primary btn-sm me-2"
                                        onClick={() => changePage(page - 1)}
                                        disabled={page === 1 || loading}
                                    >
                                        <i className="mdi mdi-chevron-left me-1"></i> Previous
                                    </button>

                                    <div className="btn-group mx-2" role="group">
                                        {pageNumbers().map((p, idx) =>
                                            p === '...' ? (
                                                <span key={idx} className="btn btn-outline-primary disabled">...</span>
                                            ) : (
                                                <button
                                                    key={idx}
                                                    className={`btn btn-sm ${p === page ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    onClick={() => changePage(p)}
                                                    disabled={loading}
                                                >
                                                    {p}
                                                </button>
                                            )
                                        )}
                                    </div>

                                    <button
                                        className="btn btn-outline-primary btn-sm ms-2"
                                        onClick={() => changePage(page + 1)}
                                        disabled={page === totalPages || loading}
                                    >
                                        Next <i className="mdi mdi-chevron-right ms-1"></i>
                                    </button>
                                </div>

                                <div className="d-flex align-items-center">
                                    <span className="text-muted small me-2">Show</span>
                                    <select
                                        value={pageSize}
                                        className="form-select form-select-sm border-primary shadow-sm"
                                        style={{ width: '70px' }}
                                        onChange={e => {
                                            setPageSize(Number(e.target.value));
                                            setPage(1);
                                        }}
                                        disabled={loading}
                                    >
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={75}>75</option>
                                    </select>
                                    <span className="text-muted small ms-2">Records</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="bottom-right" reverseOrder={false} />
        </>
    );
}
export default TagsList;